import { AuthenticatedSauceLabDataRequest } from '@eggplant/data-request'
import { type ReactElement } from 'react'
import { SUT_SERVICE } from '@eggplant/api-hosts'
import type {
  SauceLabDataRequestHeader,
  SauceLabDevice
} from '@eggplant/types'

interface Props {
  onError?: () => void
  onSuccess?: (response: SauceLabDevice[]) => void
  children?: (response: SauceLabDevice[]) => ReactElement
  shortErrorMessage?: string
  dataCenter: string
  platform: string
  sauceLabsAuthHeader: SauceLabDataRequestHeader
}

const GetSauceLabsDeviceNames = ({
  shortErrorMessage,
  onError,
  onSuccess,
  children,
  dataCenter,
  platform,
  sauceLabsAuthHeader
}: Props) => {
  const {
    apiKey,
    connectionId,
    sutId,
    userName
  } = sauceLabsAuthHeader

  const url = `${SUT_SERVICE}/sauce_labs/data_centers/${dataCenter}/device_platforms/${platform}/devices`

  return (
    <AuthenticatedSauceLabDataRequest
      apiKey={apiKey}
      children={children}
      connectionId={connectionId}
      onError={onError}
      onSuccess={onSuccess}
      shortErrorMessage={shortErrorMessage}
      sutId={sutId}
      url={url}
      userName={userName}
    />
  )
}

export default GetSauceLabsDeviceNames
